
import React, { useState, useEffect } from 'react';
import { 
    Container, Typography, Card, CardActions, CardContent, 
    CardMedia, Button, Dialog, DialogActions, DialogContent, DialogTitle, Fab, IconButton
} from '@mui/material';
import { collection, getDocs,getDoc, updateDoc, doc, setDoc, query, where ,onSnapshot} from 'firebase/firestore';
import moment from 'moment';
import { firestore } from './firebase';
import { useAuth } from './AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close'; // Import the Close icon
import {  Box } from '@mui/material';
import axios from 'axios';
import { Share as ShareIcon } from '@mui/icons-material';
import RemoveIcon from '@mui/icons-material/Remove';
import GridViewIcon from '@mui/icons-material/GridView';
import ListIcon from '@mui/icons-material/List';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import 'react-big-calendar/lib/css/react-big-calendar.css'; // Import the C

const Home = () => {
    const [events, setEvents] = useState([]);
    const [bookings, setBookings] = useState({});
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [openEventDialog, setOpenEventDialog] = useState(false);
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    const [confirmationAction, setConfirmationAction] = useState(null);
    const [selectedSeats, setSelectedSeats] = useState(1);  // Default seat count to 1
    const [view, setView] = useState('grid'); // 'grid' for card view, 'list' for table view
    const [visibleEvents, setVisibleEvents] = useState(5);  // Start with 9 events
    const [loading, setLoading] = useState(false); // Loading state
    // Function to load more events
    const localizer = momentLocalizer(moment);
    
    const [availableSeats, setAvailableSeats] = useState({});
    const [showCalendar, setShowCalendar] = React.useState(false);

    const [hoverText, setHoverText] = useState("");
    const { currentUser } = useAuth();
    const navigate = useNavigate();


  // Fetch events and seat availability
//   useEffect(() => {
//     const fetchEventsAndSeats = async () => {
//         setLoading(true);

//         try {
//             // Fetch events
//             const eventsCollection = collection(firestore, 'events');
//             const eventsSnapshot = await getDocs(eventsCollection);
//             const eventsList = eventsSnapshot.docs.map(doc => ({
//                 id: doc.id,
//                 ...doc.data()
//             }));
//             setEvents(eventsList);

//             // Fetch available seats for each event
//             const seatData = {};

//             for (const event of eventsList) {
//                 if (event.seatCount) { // Ensure seatCount exists
//                     const bookingQuery = query(
//                         collection(firestore, 'userBookings'),
//                         where('eventId', '==', event.id),
//                         where('userConfirmed', '==', true)
//                     );

//                     const bookingSnapshot = await getDocs(bookingQuery);
//                     const seatsBooked = bookingSnapshot.size; // Count of confirmed bookings

//                     seatData[event.id] = {
//                         totalSeats: event.seatCount,
//                         seatsBooked,
//                         seatsLeft: Math.max(event.seatCount - seatsBooked, 0) // Avoid negative seatsLeft
//                     };
//                 } else {
//                     // Handle cases where seatCount is missing or 0
//                     seatData[event.id] = {
//                         totalSeats: 0,
//                         seatsBooked: 0,
//                         seatsLeft: 0
//                     };
//                 }
//             }

//             setAvailableSeats(seatData);
//         } catch (error) {
//             console.error("Error fetching events and seats:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     fetchEventsAndSeats();
// }, []);


// Fetch events and seat availability
useEffect(() => {
  const fetchEventsAndSeats = async () => {
      setLoading(true);

      try {
          // Fetch events
          const eventsCollection = collection(firestore, 'events');
          const eventsSnapshot = await getDocs(eventsCollection);
          const eventsList = eventsSnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
          }));
          setEvents(eventsList);

          // Initialize seat data storage
          const seatData = {};

          // Set up listeners for each event to track bookings in real-time
          eventsList.forEach(event => {
              const seatCount = event.seatCount || 0;

              // Initialize seat data if seatCount is set
              seatData[event.id] = {
                  totalSeats: seatCount,
                  seatsBooked: 0,
                  seatsLeft: seatCount
              };

              // Real-time listener for bookings with confirmed status for the event
              const bookingQuery = query(
                  collection(firestore, 'userBookings'),
                  where('eventId', '==', event.id),
                  where('userConfirmed', '==', true)
              );

              const unsubscribe = onSnapshot(bookingQuery, (bookingSnapshot) => {
                  const seatsBooked = bookingSnapshot.size; // Count of confirmed bookings

                  // Update seat data
                  seatData[event.id] = {
                      totalSeats: seatCount,
                      seatsBooked,
                      seatsLeft: Math.max(seatCount - seatsBooked, 0) // Avoid negative seatsLeft
                  };

                  // Update available seats state dynamically
                  setAvailableSeats({ ...seatData });
              });

              // Store unsubscribe function to clean up listener on unmount
              return () => unsubscribe();
          });
      } catch (error) {
          console.error("Error fetching events and seats:", error);
      } finally {
          setLoading(false);
      }
  };

  fetchEventsAndSeats();
}, []);



  const [openDialog, setOpenDialog] = useState(false);

  // Handle event click to open dialog
  const handleSelectEvent = (event) => {
    setSelectedEvent(event); // Store the selected event
    setOpenDialog(true); // Open the dialog
  };

  // Handle closing the dialog
  const handleClose = () => {
    setOpenDialog(false);
    setSelectedEvent(null);
  };

    const bookedEvents = events.filter(event => bookings[event.id] === true).map(event => ({
      title: event.eventName,
      start: new Date(event.startTime),
      end: new Date(event.endTime),
    }));

    const loadMoreEvents = () => {
        setVisibleEvents(prev => prev + 5);  // Increase the number of visible events by 9
    };
    const generateICSFile = (eventName, eventDate, eventTime, eventDuration, eventVenue) => {
        const startDateTime = moment(`${eventDate} ${eventTime}`, 'DD-MM-YYYY HH:mm').format('YYYYMMDDTHHmmss');
        const endDateTime = moment(startDateTime, 'YYYYMMDDTHHmmss').add(eventDuration, 'minutes').format('YYYYMMDDTHHmmss');
    
        const icsContent = `
    BEGIN:VCALENDAR
    VERSION:2.0
    PRODID:-//YourCompany//YourApp//EN
    CALSCALE:GREGORIAN
    BEGIN:VEVENT
    UID:${new Date().getTime()}@yourapp.com
    DTSTAMP:${new Date().toISOString().replace(/-|:|\.\d+/g, '')}
    DTSTART:${startDateTime}
    DTEND:${endDateTime}
    SUMMARY:${eventName}
    LOCATION:${eventVenue}
    DESCRIPTION:This is a reminder for the event ${eventName} at ${eventVenue}.
    END:VEVENT
    END:VCALENDAR
        `;
    
        return icsContent.trim();
    };
    





    // Email sending functions
    const sendOrderConfirmationEmail = async (email, apiKey, orderId, eventName, eventDate, eventTime, eventDuration, eventVenue) => {
      const icsContent = generateICSFile(eventName, eventDate, eventTime, eventDuration, eventVenue);
  
      const jsonPayload = {
          email,
          subject: `Event Booking Confirmation - ${orderId}`,
          textbody: `Thank you for booking the event. Your order ID is ${orderId}.`,
          htmlbody: `
              <div style="font-family: Arial, sans-serif; color: #333;">
                  <h2 style="color: #4CAF50;">Thank you for booking the event!</h2>
                  <p>Your order ID is <strong>${orderId}</strong>.</p>
                  <h3>Event Details:</h3>
                  <p><strong>Event Name:</strong> ${eventName}</p>
                  <p><strong>Date:</strong> ${eventDate}</p>
                  <p><strong>Time:</strong> ${eventTime}</p>
              </div>`,
          attachments: [{
              filename: `${eventName}.ics`,
              content: icsContent,
              type: 'text/calendar'
          }],
          apiKey,
      };
  
      const formData = new FormData();
      formData.append('jsonPayload', JSON.stringify(jsonPayload));
  
      try {
          const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
              headers: {
                  'Content-Type': 'multipart/form-data',
              },
          });
          if (response.status === 200) {
              return 'Email sent successfully!';
          } else {
              return 'Error sending email.';
          }
      } catch (error) {
          return 'Error sending email.';
      }
  };
  
    
const sendOrderErrorEmail = async (email, apiKey, orderId, errorMessage) => {
    const jsonPayload = {
        email,
        subject: `Event Cancellation - ${orderId}`,
        textbody: `Your event order has been successfully cancelled ${orderId}.`,
        htmlbody: 
            `<div style="font-family: Arial, sans-serif; color: #333;">
                <h2 style="color: #f44336;">Event Cancellation</h2>
                <p>Your event order has been successfully canceled <strong>${orderId}</strong>.</p>
                <p>Status: ${errorMessage}</p>
                <p>Please contact our support team for assistance.</p>
            </div>`,
        apiKey,
    };

    const formData = new FormData();
    formData.append('jsonPayload', JSON.stringify(jsonPayload));

    try {
        const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        if (response.status === 200) {
            return 'Error email sent successfully!';
        } else {
            return 'Error sending error email.';
        }
    } catch (error) {
        if (error.response && error.response.status === 403) {
            return 'Invalid API key';
        } else {
            return 'Error sending error email.';
        }
    }
};





    const fetchEvents = async () => {
        try {
            const snapshot = await getDocs(collection(firestore, 'events'));
            const eventsData = snapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    startTime: data.startTime && typeof data.startTime.toDate === 'function' 
                        ? data.startTime.toDate() 
                        : null,
                    endTime: data.endTime && typeof data.endTime.toDate === 'function' 
                        ? data.endTime.toDate() 
                        : null,
                };
            });
            setEvents(eventsData);
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };
    
    const fetchUserBookings = async () => {
        if (!currentUser) return;
    
        try {
            const bookingQuery = query(
                collection(firestore, 'userBookings'), 
                where('userEmail', '==', currentUser.email)
            );
            const snapshot = await getDocs(bookingQuery);
            const bookingData = snapshot.docs.reduce((acc, doc) => {
                acc[doc.data().eventId] = doc.data().userConfirmed;
                
                return acc;
            }, {});
            setBookings(bookingData);
        } catch (error) {
            console.error('Error fetching user bookings:', error);
        }
    };
    

    useEffect(() => {
        fetchEvents();
        fetchUserBookings();
    }, [currentUser]);

    const handleOpenEventDialog = (event) => {
        setSelectedEvent(event);
        setOpenEventDialog(true);
    };

    const handleCloseEventDialog = () => {
        setOpenEventDialog(false);
        setSelectedEvent(null);
    };

    const handleConfirmationDialog = (action, event) => {
        if (!currentUser) {
            navigate('/login');
        } else {
            setConfirmationAction(action);
            setSelectedEvent(event);
            setOpenConfirmationDialog(true);
        }
    };
    
    const handleConfirmAction = async () => {
      if (!currentUser || !selectedEvent) return;
  
      // Optimistic UI update
      const optimisticBookings = { ...bookings };
      const bookingRefId = `${currentUser.email}_${selectedEvent.id}`;
  
      if (confirmationAction === 'book') {
          optimisticBookings[selectedEvent.id] = true; // Optimistically mark the event as booked
      } else if (confirmationAction === 'cancel') {
          optimisticBookings[selectedEvent.id] = false; // Optimistically mark the event as cancelled
      }
  
      // Set the updated optimistic state
      setBookings(optimisticBookings);
  
      // Close the dialog immediately for a faster user experience
      setOpenConfirmationDialog(false);
      handleCloseEventDialog();
  
      const email = currentUser.email;
      const apiKey = "qwertyuiop";
      const orderId = bookingRefId;
      const eventName = selectedEvent.eventName;
      const eventDate = moment(selectedEvent.startTime).format('DD-MM-YYYY');
      const eventTime = moment(selectedEvent.startTime).format('HH:mm');
      const eventDuration = moment(selectedEvent.endTime).diff(moment(selectedEvent.startTime), 'minutes');
      const eventVenue = selectedEvent.venue;
  
      const userProfileRef = doc(firestore, 'UserProfileMaster', currentUser.uid);
      const userProfileSnap = await getDoc(userProfileRef);
  
      if (!userProfileSnap.exists()) {
          console.error("User profile data not found.");
          return;
      }
  
      const { phoneNumber, profession } = userProfileSnap.data();
  
      setLoading(true);
  
      try {
          const bookingRef = doc(firestore, 'userBookings', bookingRefId);
  
          if (confirmationAction === 'book') {
              await setDoc(bookingRef, {
                  userEmail: currentUser.email,
                  eventId: selectedEvent.id,
                  userConfirmed: true,
                  numberOfSeats: selectedSeats,
                  phoneNumber: phoneNumber || '',
                  profession: profession || '',
              });
  
              sendOrderConfirmationEmail(email, apiKey, orderId, eventName, eventDate, eventTime, eventDuration, eventVenue);
          } else if (confirmationAction === 'cancel') {
              await updateDoc(bookingRef, { userConfirmed: false });
  
              sendOrderErrorEmail(email, apiKey, orderId, 'Your booking has been cancelled.');
          }
  
          // Fetch updated bookings from Firestore
          await fetchUserBookings();
  
      } catch (error) {
          console.error(`Error during ${confirmationAction}:`, error);
  
          // Revert optimistic update in case of an error
          const revertedBookings = { ...bookings };
          revertedBookings[selectedEvent.id] = confirmationAction === 'book' ? false : true;
          setBookings(revertedBookings);
  
          sendOrderErrorEmail(email, apiKey, orderId, error.message);
      } finally {
          setLoading(false);
      }
  };
  
    
    
    const handleDownloadICS = (event) => {
        const icsContent = generateICSFile(
            event.eventName,
            moment(event.startTime).format('DD-MM-YYYY'),
            moment(event.startTime).format('HH:mm'),
            moment(event.endTime).diff(moment(event.startTime), 'minutes'),
            event.venue
        );
    
        const blob = new Blob([icsContent], { type: 'text/calendar' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${event.eventName}.ics`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    
    const handleCancelAction = () => {
        setOpenConfirmationDialog(false);
    };
    
    const handleShareEvent = (event) => {
        const eventUrl = `${window.location.origin}/event/${event.id}`; // Generate the dynamic event URL
        
        if (navigator.share) {
            navigator.share({
                title: event.eventName,
                text: `Check out this event: ${event.eventName}`,
                url: eventUrl,
            })
            .then(() => console.log('Event shared successfully!'))
            .catch((error) => console.error('Error sharing event:', error));
        } else {
            // Fallback: copy the link to the clipboard
            navigator.clipboard.writeText(eventUrl)
                .then(() => {
                    alert('Event link copied to clipboard!');
                })
                .catch((error) => console.error('Error copying link to clipboard:', error));
        }
    };
    const sortedEvents = [...events].sort((a, b) => new Date(a.startTime) - new Date(b.startTime));   

    return (
        <Container>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography 
              variant="h5"
              sx={{
                fontWeight: 'bold',
                fontFamily: 'Roboto, Arial, sans-serif',
                padding: '20px',
                color: '#333',
                textTransform: 'uppercase'
              }}
            >
              Upcoming Events
            </Typography>
          </Box>

          {/* Show View options based on login status */}
          <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
        <IconButton color={view === 'grid' ? 'primary' : 'default'} onClick={() => setView('grid')}>
          <GridViewIcon />
        </IconButton>
        {currentUser && (
          <>
            <IconButton color={view === 'list' ? 'primary' : 'default'} onClick={() => setView('list')}>
              <ListIcon />
            </IconButton>
            <IconButton color={view === 'calendar' ? 'primary' : 'default'} onClick={() => setView('calendar')}>
              <CalendarTodayIcon />
            </IconButton>
          </>
        )}
      </Box>

    {/* Show Calendar only for logged-in users */}
    {currentUser && showCalendar && (
      <div style={{ height: '600px', marginBottom: '20px' , fontFamily: 'Arial, sans-serif'}}>
        <Calendar
          localizer={localizer}
          events={bookedEvents} // Pass booked events to the calendar
          startAccessor="start"
          endAccessor="end"
          style={{ height: 600 }}
          onSelectEvent={handleSelectEvent} 
        />


        {/* Event Details Dialog */}
      {selectedEvent && (
        <Dialog open={openDialog} onClose={handleClose}>
          <DialogTitle>Event Details</DialogTitle>
          <DialogContent>
            <Typography variant="h6">{selectedEvent.title}</Typography>
            <Typography>Date: {moment(selectedEvent.start).format('DD-MM-YYYY')}</Typography>
            <Typography>Time: {moment(selectedEvent.start).format('hh:mm A')}</Typography>
            <Typography>Duration: {selectedEvent.duration} minutes</Typography>
            <Typography>Venue: {selectedEvent.venue}</Typography>
            <Typography>Description: {selectedEvent.description}</Typography>
            {/* Show event flyer if it exists */}
            <img 
            src={selectedEvent?.flyerUrl} 
            alt={selectedEvent?.eventName} 
            style={{ 
                width: '100%', // Adjusts to the dialog's width
                maxHeight: '200px', // Ensures the image doesn't take too much space
                objectFit: 'contain', // Keeps the image aspect ratio
                marginBottom: '20px' 
            }} ></img>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}

        </div>
      )}
          {view === 'grid' && (
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
              {sortedEvents.slice(0, visibleEvents).map(event => {
                const isBooked = bookings[event.id] === true;
                return (
                  <Card 
                    key={event.id} 
                    style={{ 
                      margin: '10px', 
                      width: '300px', 
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: '0 10px 20px rgba(0, 0, 0, 0.3)'
                      }
                    }}
                    onClick={() => handleOpenEventDialog(event)}
                  >
                    <CardMedia
                      component="img"
                      height="140"
                      image={event.flyerUrl}
                      alt={event.eventName}
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {event.eventName}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {moment(event.startTime).format('DD-MM-YYYY HH:mm')} - {event.venue}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {event.freePaid} | {event.inlineOffline}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      {isBooked ? (
                        <>
                          <Typography variant="body2">
                            Seats Booked: {bookings[selectedEvent?.id]?.numberOfSeats || 1}
                          </Typography>
                          <IconButton color="error" onClick={(e) => { e.stopPropagation(); handleConfirmationDialog('cancel', event); }}>
                            <CancelIcon />
                          </IconButton>
                          <IconButton color="primary" onClick={(e) => { e.stopPropagation(); handleDownloadICS(event); }}>
                            <InsertInvitationIcon />
                          </IconButton>
                          <IconButton color="primary" onClick={(e) => { e.stopPropagation(); handleShareEvent(event); }}>
                            <ShareIcon />
                          </IconButton>
                        </>
                      )  : event.seatOption === 'Limited' && availableSeats[event.id]?.seatsLeft === 0 ? (
                        <Typography color="error" variant="body2">
                          No Seats Available
                        </Typography>
                      ) : (
                        <Button size="small" color="primary" onClick={(e) => { e.stopPropagation(); handleConfirmationDialog('book', event); }}>
                          Book Now!
                        </Button>
                      )}
                    </CardActions>
                  </Card>
                );
              })}
            </div>
          )}
    
          {view === 'list' && (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Thumbnail</TableCell>
                    <TableCell>Event Name</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Venue</TableCell>
                    <TableCell>Free/Paid</TableCell>
                    <TableCell>Online/Offline</TableCell>
                    <TableCell>Seats</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedEvents.slice(0, visibleEvents).map(event => {
                    const isBooked = bookings[event.id] === true;
                    const seatInfo = availableSeats[event.id];
                    return (
                      <TableRow key={event.id}>
                        <TableCell>
                          <img 
                            src={event.flyerUrl} 
                            alt={`${event.eventName} Flyer`} 
                            style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: '4px' }} 
                          />
                        </TableCell>
                        <TableCell>{event.eventName}</TableCell>
                        <TableCell>{moment(event.startTime).format('DD-MM-YYYY HH:mm')}</TableCell>
                        <TableCell>{event.venue}</TableCell>
                        <TableCell>{event.freePaid}</TableCell>
                        <TableCell>{event.inlineOffline}</TableCell>
                        <TableCell>
                          {/* {event.seatOption === 'Limited' ? `${event.seatCount} Seats` : 'Unlimited Seats'} */}
                          {event.seatOption === 'Limited' && seatInfo
                                                ? `${seatInfo.seatsLeft}/${seatInfo.totalSeats} Seats left`
                                                : 'Unlimited Seats'}
                        </TableCell>
                        <TableCell>
                          {isBooked ? (
                            <>
                              <IconButton color="error" onClick={() => handleConfirmationDialog('cancel', event)}>
                                <CancelIcon />
                              </IconButton>
                              <IconButton color="primary" onClick={() => handleDownloadICS(event)}>
                                <InsertInvitationIcon />
                              </IconButton>
                              <IconButton color="primary" onClick={() => handleShareEvent(event)}>
                                <ShareIcon />
                              </IconButton>
                            </>
                          ) : event.seatOption === 'Limited' && availableSeats[event.id]?.seatsLeft === 0 ? (
                            <Typography color="error" variant="body2">
                              No Seats Available
                            </Typography>
                          ): (
                            <Button size="small" color="primary" onClick={() => handleConfirmationDialog('book', event)}>
                              Book Now!
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}

{view === 'calendar' && currentUser && (
        <div style={{ height: '600px', marginBottom: '20px', fontFamily: 'Arial, sans-serif' }}>
          <Calendar
            localizer={localizer}
            events={sortedEvents.map(event => ({
              title: event.eventName,
              start: new Date(event.startTime),
              end: new Date(moment(event.startTime).add(event.duration, 'minutes')),
              allDay: false,
            }))}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 600 }}
            onSelectEvent={handleSelectEvent} // Event select handler
          />
        </div>
      )}
    
    <Dialog 
    open={openEventDialog} 
    onClose={handleCloseEventDialog}
    fullWidth
    maxWidth="sm"
    PaperProps={{
        style: {
            padding: '20px',
            minWidth: '300px', // Minimum width for mobile view
            maxWidth: '600px', // Maximum width for larger screens
            width: '100%', // Ensures full width inside the Dialog
        },
    }}
>
    <DialogTitle>
        {selectedEvent?.eventName}
        <Button 
            onClick={handleCloseEventDialog}
            style={{ position: 'absolute', top: 8, right: 8 }}
        >
            <CloseIcon />
        </Button>
    </DialogTitle>
    <DialogContent>
      
        <img 
            src={selectedEvent?.flyerUrl} 
            alt={selectedEvent?.eventName} 
            style={{ 
                width: '100%', // Adjusts to the dialog's width
                maxHeight: '200px', // Ensures the image doesn't take too much space
                objectFit: 'contain', // Keeps the image aspect ratio
                marginBottom: '20px' 
            }}
        />
        <Typography variant="body1" gutterBottom>
            {moment(selectedEvent?.startTime).format('DD-MM-YYYY')} - {moment(selectedEvent?.startTime).format('HH:mm')} - {selectedEvent?.venue}
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
            <strong>Duration:</strong> {moment(selectedEvent?.endTime).diff(moment(selectedEvent?.startTime), 'minutes')} mins
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
            <strong>Free/Paid:</strong> {selectedEvent?.freePaid}
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
            <strong>Online/Offline:</strong> {selectedEvent?.inlineOffline}
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
            <strong>Speaker Name:</strong> {selectedEvent?.speakerName}
        </Typography>

        {/* Seat selection dropdown */}
        {/* Seat selection logic based on nominee option */}
          {/* Seat Availability */}
          <Typography variant="body2" gutterBottom>
            <strong>Seats:</strong> 
            {selectedEvent?.seatOption === 'Limited' && availableSeats[selectedEvent?.id]
                ? `${availableSeats[selectedEvent.id].seatsLeft}/${availableSeats[selectedEvent.id].totalSeats} Seats left`
                : 'Unlimited Seats'}
        </Typography>
        {/* If the nominee option is Single */}
        {selectedEvent?.nomineeOption === 'Single' ? (
            <Typography variant="body2">
                1 Seat
            </Typography>
        ) : (
            <div>
                {/* If the nominee option is Multiple */}
                <IconButton onClick={() => setSelectedSeats(Math.max(selectedSeats - 1, 1))} disabled={selectedSeats <= 1}>
                    <RemoveIcon />
                </IconButton>
                <Typography variant="body2" display="inline">
                    {selectedSeats} {selectedSeats === 1 ? 'Seat' : 'Seats'}
                </Typography>
                <IconButton onClick={() => setSelectedSeats(selectedSeats + 1)}>
                    <AddIcon />
                </IconButton>
            </div>
        )}

        <Typography variant="body2" color="textSecondary" gutterBottom>
            <strong>Additional Points:</strong> {selectedEvent?.additionalPoints}
        </Typography>
    </DialogContent>
    <DialogActions>
    {selectedEvent?.seatOption === 'Limited' && availableSeats[selectedEvent?.id]?.seatsLeft === 0 ? (
        <Typography variant="body2" color="error">
            No Seats Available
        </Typography>
    ) : bookings[selectedEvent?.id] ? (
        <IconButton 
            color="secondary" 
            onClick={() => handleConfirmationDialog('cancel', selectedEvent)}
        >
            <CancelIcon />
        </IconButton>
    ) : (
        <Button 
            size="small" 
            color="primary" 
            onClick={() => handleConfirmationDialog('book', selectedEvent)}
        >
            Book Now!
        </Button>
    )}
</DialogActions>

</Dialog>


    
          <Dialog open={openConfirmationDialog} onClose={handleCancelAction}>
            <DialogTitle>
              {confirmationAction === 'book' ? 'Are you sure you want to book this event?' : 'Are you sure you want to cancel this booking?'}
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleCancelAction} color="secondary">
                Cancel
              </Button>
              <Button onClick={handleConfirmAction} color="primary">
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
    
          {visibleEvents < events.length && (
            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
              <Button variant="contained" color="primary" onClick={loadMoreEvents}>
                Load More
              </Button>
            </Box>
          )}
        </Container>
      );
    };
    
    export default Home;


